import { Link } from "react-router-dom";
import { ShieldCheck, Car, Handshake, Target, Eye, Sparkles } from "lucide-react";

export default function AboutPage() {
  return (
    <div data-testid="about-page">
      <section className="bg-[#111] text-white py-16">
        <div className="cs-container">
          <span className="inline-flex items-center gap-2 text-xs uppercase tracking-widest text-white/70 bg-white/10 border border-white/15 rounded-full px-3 py-1">About Carz Swag</span>
          <h1 className="mt-5 font-display font-extrabold text-4xl sm:text-5xl">A new standard for pre-owned cars in Delhi.</h1>
          <p className="mt-4 text-white/80 max-w-2xl leading-relaxed">
            Carz Swag is a Vikaspuri-based pre-owned car dealership built on a simple belief — buying a used car in India should feel just as premium and reliable as buying a new one.
          </p>
        </div>
      </section>

      <section className="cs-container py-14">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {[
            { icon: Target, t: "Our Mission", d: "Make buying and selling pre-owned cars transparent, trustworthy and genuinely premium." },
            { icon: Eye, t: "Our Vision", d: "Grow Carz Swag from a Delhi dealership into one of India's most trusted used-car marketplaces." },
            { icon: Sparkles, t: "Our Promise", d: "Every car tells its real story — nothing hidden, nothing exaggerated." },
          ].map((x, i) => (
            <div key={i} className="rounded-xl border border-gray-200 p-6">
              <x.icon size={22} className="text-[#940C2C]" />
              <div className="mt-3 font-display font-bold text-lg">{x.t}</div>
              <p className="mt-2 text-sm text-gray-600 leading-relaxed">{x.d}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-[#F5F5F5] py-14">
        <div className="cs-container grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div>
            <span className="text-xs font-semibold uppercase tracking-widest text-[#940C2C]">What we offer</span>
            <h2 className="mt-2 font-display font-extrabold text-3xl lg:text-4xl text-gray-900">A dealership experience without the dealership stress.</h2>
            <ul className="mt-6 space-y-3 text-gray-700">
              {["Hand-inspected certified inventory", "Transparent, honest pricing", "Easy financing & paperwork support", "Hassle-free sell-your-car service", "Dedicated after-sales support"].map((s) => (
                <li key={s} className="flex items-start gap-2"><ShieldCheck size={18} className="text-[#940C2C] shrink-0 mt-0.5" /><span>{s}</span></li>
              ))}
            </ul>
            <Link to="/buy" className="btn-primary mt-7">Explore Inventory →</Link>
          </div>
          <div className="rounded-2xl overflow-hidden">
            <img src="https://images.unsplash.com/photo-1618642624018-a370cbf3cd80?w=1400" alt="Showroom" className="w-full h-80 object-cover" />
          </div>
        </div>
      </section>

      <section className="cs-container py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-5">
          {[
            { icon: Car, t: "Curated Inventory", d: "Every car is chosen with intent." },
            { icon: ShieldCheck, t: "Inspection First", d: "Certified cars are personally inspected." },
            { icon: Handshake, t: "Fair Dealings", d: "No hidden terms, no surprises." },
            { icon: Sparkles, t: "Future Ready", d: "Built for growth — more locations, more cars." },
          ].map((x, i) => (
            <div key={i} className="rounded-xl bg-white border border-gray-200 p-5">
              <x.icon size={20} className="text-[#940C2C]" />
              <div className="mt-3 font-display font-bold">{x.t}</div>
              <p className="mt-1 text-sm text-gray-600">{x.d}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
